import { cx } from '@linaria/core';
import { CheckmarkIcon } from '../../../icons/checkmark.js';
import { checkmark, modifiers } from './checkmark.style.js';
import { jsx } from 'react/jsx-runtime';

/**
 * Renders a checkmark that can be hovered and toggled. Do note that this
 * component does not act as an input, but only includes UI rendering.
 */
function Checkmark(props) {
  return /*#__PURE__*/jsx("div", {
    className: cx(checkmark, props.toggled && modifiers.toggled.className),
    children: /*#__PURE__*/jsx(CheckmarkIcon, {})
  });
}

export { Checkmark };
//# sourceMappingURL=checkmark.js.map
